import { Injectable } from '@angular/core';

import { Baseservice } from './baseservice';
import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TransportAssocService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('transport/assoc', http, authentication);
  } 

  listTransportAssoc() {
    return this.getRequest(`${this.url}/ddl`);
  }
  getTransporAssocById(id){
    return this.getRequest(`${this.url}/`+id);
  }

}
